// @flow
import React, { Component } from "react";
import moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DateRangeIcon from "@material-ui/icons/DateRange";
import { withStyles, withTheme } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { iconStyles } from "../../styles/iconStyles";
import {
  DatetoEndTimeAppend,
  JsDateObjectDisplayDateOnly,
  DatetoStartTimeAppend
} from "../../functions/dateTimeFunctions";
import StyledTextField from "./StyledTextField";
import GeneralModalForm from "../Gadgets/GeneralModalForm";

type InfiniteCalendarSelectPropsType = {
  classes: IconStylesClassesType,
  theme: DictionaryType,
  label: string,
  name: string,
  value: Date | null,
  syncDateChange: Function,
  calendarLib: *,
  min_date?: Date,
  max_date?: Date,
  isEndDate?: boolean,
  isRequired?: boolean
};

type InfiniteCalendarSelectStateType = {
  isOpen: boolean,
  displayDate: string,
  realDate: Date | null,
  isInvalid: boolean
};

class InfiniteCalendarBase extends Component<
  InfiniteCalendarSelectPropsType,
  InfiniteCalendarSelectStateType
> {
  timeout: *;
  constructor(props: InfiniteCalendarSelectPropsType) {
    super(props);
    this.state = {
      isOpen: false,
      displayDate: props.value ? JsDateObjectDisplayDateOnly(props.value) : "",
      realDate: props.value || null,
      isInvalid: false
    };
  }

  openDatePicker = () => {
    this.setState({ isOpen: true });
  };

  handleRequestClose = () => {
    this.setState({ isOpen: false });
  };

  componentDidUpdate(prevProps: InfiniteCalendarSelectPropsType) {
    if (prevProps.value !== this.props.value) {
      if (this.props.value === null) {
        this.setState({
          realDate: null,
          displayDate: this.state.displayDate
        });
      } else {
        this.setState({
          realDate: this.props.value,
          displayDate: this.props.value
            ? JsDateObjectDisplayDateOnly(this.props.value)
            : ""
        });
      }
    }
  }

  handleTextChange = (e: SyntheticInputEvent<*>): * => {
    const value = e.target.value;
    this.setState({ displayDate: value }, this.getRealDate);
  };

  getRealDate = (): * => {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(
      function() {
        if (this.state.displayDate !== "") {
          if (moment(this.state.displayDate, "DD/MMM/YYYY").isValid()) {
            let readlDate = this.props.isEndDate
              ? DatetoEndTimeAppend(moment(this.state.displayDate))
              : DatetoStartTimeAppend(moment(this.state.displayDate));
            let displayDate = JsDateObjectDisplayDateOnly(readlDate);
            this.setState(
              {
                realDate: readlDate,
                displayDate: displayDate,
                isInvalid: false
              },
              this.syncDateChange
            );
          } else {
            this.setState(
              { realDate: null, isInvalid: true },
              this.syncDateChange
            );
          }
        } else {
          this.setState(
            { realDate: null, isInvalid: false },
            this.syncDateChange
          );
        }
      }.bind(this),
      1000
    );
  };

  handleDateChange = (date: Date) => {
    this.setState(
      {
        realDate: this.props.isEndDate
          ? DatetoEndTimeAppend(date)
          : DatetoStartTimeAppend(date),
        displayDate: JsDateObjectDisplayDateOnly(date),
        isOpen: false,
        isInvalid: false
      },
      this.syncDateChange
    );
  };

  syncDateChange = (): * => {
    this.props.syncDateChange(this.props.name, this.state.realDate);
  };

  render(): * {
    const { classes, theme } = this.props;
    const CalendarForm = this.props.calendarLib;

    return (
      <div>
        <StyledTextField
          isRequired={this.props.isRequired}
          isInvalid={this.state.isInvalid}
          label={this.props.label}
          name="displayDate"
          value={this.state.displayDate}
          onChange={this.handleTextChange}
          inpuType="text"
          helper="format: 01/Jan/2018"
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={this.openDatePicker}>
                <DateRangeIcon className={classes.shineIcon} />
              </IconButton>
            </InputAdornment>
          }
        />
        <GeneralModalForm
          title="Pick a Date"
          open={this.state.isOpen}
          handleModalStatus={this.handleRequestClose}
          notFullWidth
          form={
            <CalendarForm
              width={window.innerWidth <= 400 ? window.innerWidth : 400}
              height={window.innerHeight - 250}
              selected={this.state.realDate}
              {...(this.props.min_date ? { minDate: this.props.min_date } : {})}
              {...(this.props.max_date ? { maxDate: this.props.max_date } : {})}
              onSelect={this.handleDateChange}
              theme={{
                selectionColor: theme.palette.primary.main,
                headerColor: theme.palette.primary.third,
                weekdayColor: theme.palette.primary.main,
                floatingNav: {
                  background: theme.palette.primary.third,
                  color: theme.palette.primary.contrastText
                }
              }}
            />
          }
        />
      </div>
    );
  }
}

export default withStyles(iconStyles, { withTheme: true })(
  InfiniteCalendarBase
);
